import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CompanyTypeConfigGrid extends BaseComponent {
	
	static get properties() {
		return {
		};
	}
	
	constructor() {
		super();
	
		var configGrid = this;
		setTimeout(function(){
			configGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var configGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_COMPANY_TYPE_CONFIG:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_COMPANY_TYPE_CONFIG:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',						
							theme: 'error primary',
							itemid: 'delete',
							disabled: true,
							'class': 'spacer-toolbar-item',
							style: 'float: right;',
							permissions: ['ADMIN_COMPANY_TYPE_CONFIG:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'wrap-cell-content row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'companyType',
					header: 'Company Type',
					width: '7em'
				},
				{						
					path: 'supportEmail',
					header: 'Email',
					width: '7em'
				},
				{						
					path: 'supportPhone',
					header: 'Phone',
					width: '7em'
				},
				{						
					path: 'applicationName',
					header: 'App Name',
					width: '7em'
				},
				{						
					path: 'templates',
					header: 'Template',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.templates) {
							var display = '';
							rowData.item.templates.forEach(function(item){
								display += '&bullet; Type: ' + item.type + ' Template: ' + item.templateName + '<br>';
							});
							root.innerHTML = display;
						} else {
							root.innerHTML = '';
						}
					}
				},	
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		configGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			var loadMask = grid.showLoading();
			
			Service.getCompanyTypeConfigService().getConfigs().then(function(data){
				loadMask.remove();
				grid.activeItem = null;
				grid.items = data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var templates = [];
						var templatesGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'type',
									header: 'Type',					
									width: '7em'
								},
								{
									path: 'templateName',
									header: 'Template Name',					
									width: '7em'
								},
								{
									path: 'templateId',
									header: 'Template Id',					
									'flex-grow': '1'
								},
								{
									path: 'templateDescription',
									header: 'Description',					
									'flex-grow': '1'
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									templatesGrid.selectedItems = item ? [item] : [];
									if (templatesGrid.selectedItems.length > 0) {											
										ElementUtil.query(formPanel, 'editItem').disabled = false;
										ElementUtil.query(formPanel, 'removeItem').disabled = false;
									} else {	
										ElementUtil.query(formPanel, 'editItem').disabled = true;										
										ElementUtil.query(formPanel, 'removeItem').disabled = true;
									}	
								}
							}
						});	
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											itemId: 'companyType',
											label: 'Company Type',
											name: 'companyType',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('CompanyType').then(function (data) {
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'supportEmail',
											label: 'Email',											
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-text-field',										
											name: 'supportPhone',
											label: 'Phone'
										},
										{
											tag: 'vaadin-text-field',										
											name: 'applicationName',
											label: 'Application Name'
										},
										{
											tag: 'vaadin-text-field',										
											name: 'parentCarrierIds',
											label: 'Parent Carrier Ids',
											'helper-text': 'comma-separated'
										},
										{
											tag: 'dl-section-title',
											title: 'Template',
											style: 'margin-top: 10px;',
											colspan: 2
										},										
										{
											tag: 'div',
											style: 'height: 250px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'addItem',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditTemplate();
																		}
																	}					
																},	
																{
																	tag: 'vaadin-button',
																	itemid: 'editItem',																	
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:edit', ' Edit')
																	],
																	listeners: {
																		click: function() {							
																			actionAddEditTemplate(templatesGrid.selectedItems[0]);
																		}
																	}					
																},
																{
																	tag: 'vaadin-button',
																	itemid: 'removeItem',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionDeleteTemplate(templatesGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														templatesGrid										
													]
												}								
											]
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																																
															formPanel.submitForm({
																preSubmit: function (data) {
																	data.templates = templates;																	
																	return data;
																},
																actualCall: function (data) {																	
																	return Service.getCompanyTypeConfigService().saveConfig(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Config', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);

						if (record) {							
							var loadMask = formPanel.showLoading();
							Service.getCompanyTypeConfigService().getConfig(record.companyType).then(function(detailRecord){
								loadMask.remove();
								
								formPanel.load(detailRecord);
								ElementUtil.query(formPanel, 'companyType').readOnly = true;
							
								//load templates
								templates = detailRecord.templateViews.slice(0);
								actionRefreshTemplates();								
								
							}, function() {
								loadMask.remove();
							});					
						}
						
						var actionRefreshTemplates = function() {
							templatesGrid.activeItem = null;
							templatesGrid.items = templates.slice(0);
						};
						
						var actionAddEditTemplate = function(template) {
							var addEditItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (template ? 'Edit' : 'Add') + ' Template',
								icon: 'vaadin:edit',
								width: .65,
								height: 225,
								listeners: {
									ready: function () {
										addEditItemWin.show();

										var templateFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															label: 'Type',
															name: 'type',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('CompanyTypeTemplateType').then(function (data) {
																	combo.items = data;
																});
															}
														},
														{
															tag: 'vaadin-text-field',
															label: 'Template Name',
															name: 'templateName',
															required: true,
															maxLength: 255
														},	
														{
															tag: 'vaadin-combo-box',
															itemId: 'actualTemplate',
															label: 'Actual Template',
															name: 'templateId',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															postinit: function (combo) {
																Service.getCompanyTypeConfigService().getAvailableTemplates().then(function (data) {
																	combo.items = data;
																});
															}
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function () {																			

																			var data = templateFormPanel.getData();
																			var templateDescription = ElementUtil.query(templateFormPanel, 'actualTemplate').selectedItem.description;
																			data.templateDescription = templateDescription;

																			if (template) {
																				template.type = data.type;
																				template.templateName = data.templateName;
																				template.templateId = data.templateId;
																				template.templateDescription = data.templateDescription;
																			} else {
																				templates.push(data);
																			}
																			
																			actionRefreshTemplates();																			
																			addEditItemWin.close();

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addEditItemWin.addToContentElement(templateFormPanel);

										if (template) {
											//load details ...unpack																		
											templateFormPanel.load(template);
										}

									}
								}
							});
						};
						
						var actionDeleteTemplate = function(template) {
							var newItems = [];
							templates.forEach(function (item) {
								if (item.type !== template.type && item.templateName !== template.templateName) {
									newItems.push(item);
								}
							});
							templates = newItems;							
							actionRefreshTemplates();			
						};
						
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: '<b>Are you sure you want to delete "' + record.companyType + '"?</b> <br><i class="fas fa-exclamation-triangle warning-icon"></i>Existing companies of this type will use defaults.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							Service.getCompanyTypeConfigService().deleteConfig(record.companyType)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed '+ record.companyType, {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
	}
	
}
customElements.define('dl-company-type-config-grid', CompanyTypeConfigGrid);